import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/login.vue'),
    meta: {
      hideHead: true
    }
  },
  {
    path: '/register',//注册
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/register.vue'),
    meta: {
      hideHead: true
    }
  },
  {
    path: '/passwordRecover',//忘记密码
    name: 'passwordRecover',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/password-recover.vue'),
    meta: {
      hideHead: true
    }
  },
  {
    path: '/dataAnalysis',
    name: 'dataAnalysis',
    redirect: "/dataAnalysis/fabric",
    component: () => import('../views/dataAnalysis/index.vue'),
    children: [
      {
        path: "/dataAnalysis/fabric",
        name: "dataAnalysisFabric",
        meta: {
          login: true
        },
        component: () => import('../views/dataAnalysis/fabric.vue')
      }
    ]
  },
  // 产品申报
  {
    path: '/',
    name: 'competition-index',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/index.vue'),
    meta: {
      headerType: 1
    }
  },
  {
    path: '/competition/fabrics',
    name: 'competition-fabrics',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/competitionInfo/competition-fabrics.vue'),
    meta: {
      headerType: 1
    }
  },
  // 大赛详情
  {
    path: '/competition/ecology',
    name: 'competition-ecology',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/competitionInfo/ecology.vue'),
    meta: {
      headerType: 1
    }
  },
  {
    path: '/competition/fashion',
    name: 'competition-fashion',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/competitionInfo/fashion.vue'),
    meta: {
      headerType: 1
    }
  },
  {
    path: '/competition/international',
    name: 'competition-international',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/competitionInfo/international.vue'),
    meta: {
      headerType: 1
    }
  },
  //申报表单
  {
    path: '/competition/declare',
    name: 'competition-declare',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/declare/declare.vue'),
    meta: {
      login: true
    }
  },
  // 申报记录
  {
    path: '/competition/declareRecord',
    name: 'competition-declareRecord',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/declare/record.vue'),
    meta: {
      login: true,
      navSign: '1'
    }
  },
  //企业信息
  {
    path: '/competition/company',
    name: 'competition-company',
    redirect: "/competition/company/companyInfo",
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/companyInfo/company.vue'),
    children: [
      {
        path: "/competition/company/companyInfo",
        name: "companyInfo",
        component: () => import('../views/competition/companyInfo/companyInfo.vue'),
        meta: {
          login: true
        }
      },
      {
        path: "/competition/company/invoice",
        name: "invoice",
        component: () => import('../views/competition/companyInfo/invoice.vue'),
        meta: {
          login: true
        }
      },
      {
        path: "/competition/company/account",
        name: "account",
        component: () => import('../views/competition/companyInfo/account.vue'),
        meta: {
          login: true
        }
      }
    ]
  },
  // 英文网站
  // 登录注册
  {
    path: '/en/login',
    name: 'en-login',
    component: () => import(/* webpackChunkName: "about" */ '../views/en/login/login.vue'),
    meta: {
      en: true,
      hideHead: true
    }
  },
  {
    path: '/en/register',//注册
    name: 'en-register',
    component: () => import(/* webpackChunkName: "about" */ '../views/en/login/register.vue'),
    meta: {
      en: true,
      hideHead: true
    }
  },
  {
    path: '/en/passwordRecover',//忘记密码
    name: 'en-passwordRecover',
    component: () => import(/* webpackChunkName: "about" */ '../views/en/login/password-recover.vue'),
    meta: {
      en: true,
      hideHead: true
    }
  },
  // 申报记录
  {
    path: '/en/competition/declareRecord',
    name: 'competition-declareRecord-en',
    component: () => import(/* webpackChunkName: "about" */ '../views/en/competition/record.vue'),
    meta: {
      en: true,
      login: true
    }
  },
  {
    path: '/en/competition/declare',
    name: 'competition-declare-en',
    component: () => import(/* webpackChunkName: "about" */ '../views/en/competition/declare.vue'),
    meta: {
      en: true,
      login: true
    }
  },
  //企业信息
  {
    path: '/en/competition/company',
    name: 'en-competition-company',
    redirect: "/en/competition/company/companyInfo",
    component: () => import(/* webpackChunkName: "about" */ '../views/en/companyInfo/company.vue'),
    children: [
      {
        path: "/en/competition/company/companyInfo",
        name: "en-companyInfo",
        component: () => import('../views/en/companyInfo/companyInfo.vue'),
        meta: {
          en: true,
          login: true
        }
      },
      {
        path: "/en/competition/company/invoice",
        name: "en-invoice",
        component: () => import('../views/en/companyInfo/invoice.vue'),
        meta: {
          en: true,
          login: true
        }
      },
      {
        path: "/en/competition/company/account",
        name: "en-account",
        component: () => import('../views/en/companyInfo/account.vue'),
        meta: {
          en: true,
          login: true
        }
      }
    ]
  },
  //空白页 当前路由刷新
  {
    path: '/refresh',
    name: 'refresh',
    component: () => import('../views/refresh.vue')
  },
  {
    path: '/nothing',
    name: 'nothing',
    component: () => import('../views/404.vue')
  }
]

const router = new VueRouter({
  routes
})

//全局前置路由守卫
router.beforeEach((to, from, next) => {
  // console.log(1,to , from);
  window.onresize = null;
  window.onscroll = null;
	let title = to.meta.title?to.meta.title: "中国国际面料设计大赛"
  if(to.meta.whiteBG){
    document.body.style.backgroundColor = "#fff"
  }else{
    document.body.style.backgroundColor = "#fafafa"
  }
	document.title = title;
  next()
});

//重复路由跳转报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
};

export default router
